<template>
  <v-card>
    <v-card-title>
      custom
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-date-picker no-title v-model="startDate" type="date" scrollable>
        </v-date-picker>
        <v-time-picker v-if="modal" no-title format="24hr" v-model="startTime"></v-time-picker>
      </v-row>
      <v-row class="pa-2">
        Start {{startDate}} {{startTime}}
      </v-row>
      <v-row>
        <v-date-picker no-title v-model="endDate" type="date" scrollable>
        </v-date-picker>
        <v-time-picker v-if="modal" no-title format="24hr" v-model="endTime"></v-time-picker>
      </v-row>
      <v-row>
        Stop {{endDate}} {{endTime}}
      </v-row>
      <v-row justify="center" class="pa-2">
        <v-btn color="warning" @click="cancel">Cancel</v-btn>
        <v-btn color="info" @click="save">OK</v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import EventBus from '@/utils/EventBus';

export default {
  props: {
    modal: {
      type: Boolean,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
  },
  watch: {
    start: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler(val) {
        this.startDate = val.slice(0, 10);
        this.startTime = val.slice(11, 16);
      },
    },
    end: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler(val) {
        this.endDate = val.slice(0, 10);
        this.endTime = val.slice(11, 16);
      },
    },
  },
  data() {
    return {
      startDate: this.start.slice(0, 10),
      startTime: this.start.slice(11, 16),
      endDate: this.end.slice(0, 10),
      endTime: this.end.slice(11, 16),
    };
  },
  computed: {
  },
  created() {
  },
  beforeDestroy() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  mounted() {
  },
  methods: {
    save() {
      const startTime = new Date(`${this.startDate}T${this.startTime}`).toISOString();
      const endTime = new Date(`${this.endDate}T${this.endTime}`).toISOString();
      /*
      EventBus.$emit('monitoring-time-changed', { startTime, endTime });
      this.$emit('update:toggle_timestamp', 3);
      this.$emit('update:modal', false);
      */
      EventBus.$emit('date-picker-closed', { changed: true, startTime, endTime });
    },
    cancel() {
      /*
      console.log(this.toggle_timestamp);
      setTimeout(() => {
        console.log(`now emit ${this.toggle_timestamp}`);
        this.$emit('update:toggle_timestamp', this.toggle_timestamp);
      }, 1000);

      this.$emit('update:modal', false);
      */
      EventBus.$emit('date-picker-closed', { changed: false });
    },
  },
};
</script>
